import Hotjar from '@hotjar/browser';

export const hotjarSiteId = 5307766;

export const initializeHotjarTracking = () => Hotjar.init(hotjarSiteId, 6);
